import {
  type ListenerEffect,
  type UnknownAction,
  createListenerMiddleware,
} from '@reduxjs/toolkit';
import type { TAppDispatch, TRootState } from './store';

export const listenerMiddleware = createListenerMiddleware();
export const startAppListening = listenerMiddleware.startListening.withTypes<
  TRootState,
  TAppDispatch
>();

export type StartAppListeningPredicate = (
  action: UnknownAction,
  currentState: TRootState,
  previousState: TRootState
) => boolean;

export type StartAppListenerEffect = ListenerEffect<
  UnknownAction,
  TRootState,
  TAppDispatch
>;
